module.exports = __webpack_public_path__ + "static/img/manual-10.1f6986b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-10.png
// module id = 1hOc
// module chunks = 4